import { render, staticRenderFns } from "./TheSideImage.vue?vue&type=template&id=2cefbafb&scoped=true"
import script from "./TheSideImage.vue?vue&type=script&lang=js"
export * from "./TheSideImage.vue?vue&type=script&lang=js"
import style0 from "./TheSideImage.vue?vue&type=style&index=0&id=2cefbafb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cefbafb",
  null
  
)

export default component.exports